/** Build owner preview URL with human-readable salon slug (token stays in query). */
export function salonPreviewUrl(slug: string, token: string): string {
  const s = slug.trim()
  const t = token.trim()
  if (!s || !t) return '/salon/website'
  return `/preview/${encodeURIComponent(s)}?t=${encodeURIComponent(t)}`
}

/** Platform routes that must never be treated as a partner salon slug. */
export const RESERVED_PUBLIC_SLUGS = new Set([
  's',
  'login',
  'register',
  'forgot-password',
  'reset-password',
  'verify-email',
  'book',
  'shop',
  'cart',
  'club',
  'display',
  'tv',
  'qr',
  'contact',
  'kontakt',
  'faq',
  'fragen',
  'impressum',
  'datenschutz',
  'agb',
  'privacy',
  'terms',
  'legal',
  'subscriptions',
  'memberships',
  'subscribe',
  'plans',
  'admin',
  'salon',
  'account',
  'employee',
  'preview',
  'branches',
  'filialen',
  'unsere-filialen',
  'leistungen',
  'services',
  'styles',
  'stile',
  'ilia-barbershop',
  'assets',
  'api',
  'branding',
])

/** Published public site: /{slug} or /{slug}/book */
export function salonPublicPath(slug: string, suffix = ''): string {
  const s = slug.trim().replace(/^\/+/, '')
  if (!s) return '/'
  const rest = suffix.replace(/^\/+/, '').replace(/\/+$/, '')
  return rest ? `/${s}/${rest}` : `/${s}`
}

/** Published public site. */
export function salonPublicUrl(slug: string): string {
  return salonPublicPath(slug)
}

export function salonSlugFromPath(pathname: string | null | undefined): string | null {
  if (!pathname) return null
  const parts = pathname.split('/').filter(Boolean)
  if (parts.length === 0) return null
  if (parts[0] === 's' && parts[1] && !RESERVED_PUBLIC_SLUGS.has(parts[1])) return parts[1]
  if (!RESERVED_PUBLIC_SLUGS.has(parts[0])) return parts[0]
  return null
}
